import './MobileBottomNav.css';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../utils/texts';
import { useMainNav } from '../../context/MainNavContext';

type NavItemProps = {
    text: string;
    icon: React.ReactNode;
    path?: string;
    onClick?: () => void;
    active?: boolean;
};

const MobileNavItem = ({ text, icon, path, onClick, active }: NavItemProps) => {
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();
    const commonStyles = `mobile-nav-item${active ? ' nav-active' : ''}`;

    if (path !== undefined || path === '') {
        return (
            <Link to={`/${municipalitaId}/${bodyType}/${zastupitelstvoId}/${path}`} className={commonStyles}>
                {icon}
                <p className='mobile-nav-item-text'>{text}</p>
            </Link>
        );
    } else {
        return (
            <div onClick={onClick} className={commonStyles}>
                {icon}
                <p className='mobile-nav-item-text'>{text}</p>
            </div>
        );
    }
};

type Props = {
    isVisible: boolean;
};

const MobileBottomNav = ({ isVisible }: Props) => {
    const { t } = useTranslation();
    const { setMainNavVisible } = useMainNav();

    const navItems = [
        {
            text: t('Overview'),
            path: '',
            icon: <span className='material-symbols-rounded'>home</span>
        },
        {
            text: t('Votings'),
            path: 'hlasovani',
            icon: <span className='material-symbols-rounded'>check_box</span>
        },
        {
            text: t('Composition'),
            path: 'zastupitele',
            icon: <span className='material-symbols-rounded'>groups</span>
        },
        {
            text: capitalizeFirstLetter(t('meetings')),
            path: 'zasedani',
            icon: <span className='material-symbols-rounded'>article</span>
        },
        {
            text: t('Analyses'),
            path: 'analyzy',
            icon: <span className='material-symbols-rounded'>analytics</span>
        },
        {
            text: t('menu'),
            onClick: () => setMainNavVisible(true),
            icon: <span className='material-symbols-rounded'>menu</span>
        }
    ];

    const activeItemIndex = navItems.findIndex((item) => {
        const path = window.location.pathname.split('/');
        const lastPath = path[path.length - 1];
        return lastPath === item.path;
    });

    return (
        <div className={`mobile-nav ${isVisible ? 'nav-visible' : 'nav-hidden'}`}>
            {navItems.map((item, index) => (
                <MobileNavItem key={index} {...item} active={activeItemIndex === index} />
            ))}
        </div>
    );
};

export default MobileBottomNav;
